export class EmailValidator {
    public static validate(value: string): boolean {
        return /(.+)@(.+){2,}\.(.+){2,}/.test(value);
    }
}
